import { useQuery } from "@tanstack/react-query";
import { useStore } from "../../../helpers";
import { fetchNotebookContext } from "./fetchNotebookContext";

export type { GetContextResponse } from "./fetchNotebookContext";

export const useGetContext = (
  notebookId: number | null,
  enabled: boolean,
  version?: number
) => {
  const rootStore = useStore();
  const isEnabled = Boolean(enabled && notebookId != null && !Number.isNaN(notebookId));

  return useQuery({
    queryKey: ["tars", "contexts", "get", notebookId, version],
    queryFn: () => fetchNotebookContext(rootStore.api, notebookId!, version),
    enabled: isEnabled,
    retry: false,
  });
};
